// extracted by mini-css-extract-plugin
module.exports = {"switch":"GoLiveOptionsModal_switch__cTwo_","footer":"GoLiveOptionsModal_footer___L_dN"};